<template>
  <page-wrapper ref="pageEl" :title="title">
    <loading-overlay :active="isLoading" />
    <div v-if="!$isCallCenter" class="header">
      <sc-button
        :route="createButton.route"
        class="create-button"
        variant="primary"
        >{{ createButton.text }}</sc-button
      >
      <sc-button :route="{ name: 'PackageOrderingPage' }" variant="secondary"
        >จัดลำดับการแสดงผล</sc-button
      >
    </div>
    <div class="wrapper">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 mb-3">
          <div class="label mb-2">ชื่อแพ็กเกจ</div>
          <el-input v-model="packageName" />
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-3">
          <div class="label mb-2">โครงการที่รองรับ</div>
          <project-select v-model="selectedProject"></project-select>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-3">
          <label class="label mb-2">ผู้ให้บริการ</label>
          <provider-selector
            v-model="provider"
            class="input"
          ></provider-selector>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-3">
          <div class="label mb-2">กลุ่มแพ็กเกจ</div>
          <el-select v-model="packageGroup" style="width: 100%">
            <el-option
              v-for="option in packageGroupOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-3">
          <div class="label mb-2">สถานะการขาย</div>
          <el-select v-model="saleStatus" style="width: 100%">
            <el-option
              v-for="option in saleStatusOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-3">
          <div class="label mb-2">สถานะการแสดงผลในแอปฯ</div>
          <el-select v-model="appVisibility" style="width: 100%">
            <el-option
              v-for="option in appVisibilityOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-3">
          <el-checkbox v-model="includeSubPackages"
            >แสดงแพ็กเกจย่อย</el-checkbox
          >
        </div>
        <div class="col-12 col-lg-4 mb-3 text-center filter-actions">
          <sc-button variant="secondary" @click="handleClickClear"
            >ล้างตัวกรอง</sc-button
          >
          <sc-button class="ml-2" variant="primary" @click="handleClickSearch"
            >ค้นหา</sc-button
          >
        </div>
      </div>
      <div v-if="list.length">
        <p v-if="total" class="mb-2 mt-2">{{ totalCount }}</p>
        <div>
          <package-list-item
            v-for="item in list"
            :key="item.id"
            v-bind="item"
          ></package-list-item>
          <div class="text-end mt-4">
            <el-pagination
              :total="total"
              :page-size="10"
              :current-page="queryParams.page"
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-else-if="!isLoading" class="text-center p-5">
        <h3>ไม่มีข้อมูล</h3>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import LoadingOverlay from "@/lib/components/LoadingOverlay"
import PageWrapper from "@/lib/components/PageWrapper"
import ProjectSelect from "@/lib/components/ProjectSelect"
import ProviderSelector from "@/lib/components/ProviderSelector"
import ScButton from "@/lib/components/ScButton"
import { Checkbox, Input, Option, Pagination, Select } from "element-ui"
import PackageListItem from "../components/PackageListItem"

const DEFAULT_FILTERS = {
  packageGroup: "all",
  saleStatus: "all",
  appVisibility: "all",
  includeSubPackages: false,
}

const PACKAGE_GROUP_OPTIONS = [
  { label: "ทั้งหมด", value: "all" },
  { label: "Lifestyle", value: "lifestyle" },
  { label: "Home Expert", value: "home_expert" },
]

const SALE_STATUS_OPTIONS = [
  { label: "ทั้งหมด", value: "all" },
  { label: "เปิดขาย", value: "on_sale" },
  { label: "ปิดขาย", value: "off_sale" },
]

const APP_VISIBILITY_OPTIONS = [
  { label: "ทั้งหมด", value: "all" },
  { label: "แสดงในแอปฯ", value: "visible" },
  { label: "ซ่อนจากแอปฯ", value: "hidden" },
]

export default {
  components: {
    PageWrapper,
    PackageListItem,
    ScButton,
    LoadingOverlay,
    "el-input": Input,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    ProjectSelect,
    ProviderSelector,
  },
  data() {
    const title = "รายการแพ็กเกจ"
    const createButton = {
      text: "เพิ่มแพ็กเกจ",
      route: { name: "PackageCreatePage" },
    }
    const list = []
    const total = 0
    const packageName = null
    const selectedProject = null

    return {
      title,
      list,
      createButton,
      packageName,
      total,
      selectedProject,
      packageGroup: DEFAULT_FILTERS.packageGroup,
      saleStatus: DEFAULT_FILTERS.saleStatus,
      appVisibility: DEFAULT_FILTERS.appVisibility,
      includeSubPackages: DEFAULT_FILTERS.includeSubPackages,
      provider: null,
      packageGroupOptions: PACKAGE_GROUP_OPTIONS,
      saleStatusOptions: SALE_STATUS_OPTIONS,
      appVisibilityOptions: APP_VISIBILITY_OPTIONS,
      isLoading: false
    };
  },
  computed: {
    totalCount() {
      const limit = 10
      const currentTotalItem = this.list.length
      const isLastPage = limit > currentTotalItem
      const currentPage = this.queryParams.page
      const endNum = isLastPage ? this.total : currentPage * limit
      const startNum = (isLastPage ? limit * currentPage - limit : endNum - limit) + 1

      return `แสดงผล ${startNum.toLocaleString()} - ${endNum.toLocaleString()} จากทั้งหมด ${this.total.toLocaleString()}`
    },
    appliedFilters() {
      const { query } = this.$route
      const name = query.name ? query.name.trim() : null

      return {
        name: name || null,
        projectId: query.projectId || null,
        providerId: query.providerId || null,
        packageGroup: query.packageGroup || DEFAULT_FILTERS.packageGroup,
        saleStatus: query.saleStatus || DEFAULT_FILTERS.saleStatus,
        appVisibility: query.appVisibility || DEFAULT_FILTERS.appVisibility,
        includeSubPackages:
          query.includeSubPackages ||
          String(DEFAULT_FILTERS.includeSubPackages),
      }
    },
    queryParams() {
      const parsedPage = parseInt(this.$route.query.page, 10) || 1
      const page = parsedPage > 0 ? parsedPage : 1

      return {
        page,
        ...this.appliedFilters,
      }
    },
  },
  watch: {
    "$route.query": async function watchRouteQuery() {
      await this.setupData()

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
  },
  mounted() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupQuery()
      this.setupData()
    },
    setupQuery() {
      this.packageName = this.$route.query.name
      this.selectedProject = this.$route.query.projectId
        ? {
            projectId: this.$route.query.projectId,
            projectName: this.$route.query.projectName,
          }
        : null
      this.packageGroup =
        this.$route.query.packageGroup || DEFAULT_FILTERS.packageGroup
      this.saleStatus =
        this.$route.query.saleStatus || DEFAULT_FILTERS.saleStatus
      this.appVisibility =
        this.$route.query.appVisibility || DEFAULT_FILTERS.appVisibility
      this.includeSubPackages = this.$route.query.includeSubPackages
        ? this.$route.query.includeSubPackages === "true"
        : DEFAULT_FILTERS.includeSubPackages
      this.provider = this.$route.query.providerId
        ? { id: this.$route.query.providerId }
        : null
    },
    setupData() {
      this.setupList()
    },
    async setupList() {
      this.isLoading = true;
      try {
        const params = this.queryParams;
        const { count, packages } = await this.fetchList(params);
        this.total = count;

        this.list = packages.map((item) => this.mapListItem(item))
      } finally {
        this.isLoading = false;
      }
    },
    mapListItem(item) {
      const {
        id,
        name,
        price,
        billing_cycle: billingCycle,
        target,
        detail,
        image_url: imageUrl,
        original_price: originalPrice,
      } = item
      const route = { name: "PackageDetailPage", params: { id } }

      return {
        id,
        imageUrl,
        name,
        price,
        billingCycle,
        target,
        detail,
        originalPrice,
        route,
      }
    },
    async fetchList(params) {
      const response =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.listAllType(
          params,
        )

      return response.data.result
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { page, ...this.appliedFilters },
      }

      this.$router.replace(route)
    },
    buildSearchQuery() {
      const name = this.packageName ? this.packageName.trim() : null

      return {
        page: 1,
        name: name || null,
        projectId: this.selectedProject
          ? this.selectedProject.projectId
          : null,
        providerId: this.provider ? this.provider.id : null,
        packageGroup: this.packageGroup,
        saleStatus: this.saleStatus,
        appVisibility: this.appVisibility,
        includeSubPackages: String(this.includeSubPackages),
      }
    },
    async handleClickSearch() {
      const route = {
        name: this.$route.name,
        query: this.buildSearchQuery(),
      }

      this.$router.replace(route)
    },
    handleClickClear() {
      this.packageName = null
      this.selectedProject = null
      this.provider = null
      this.packageGroup = DEFAULT_FILTERS.packageGroup
      this.saleStatus = DEFAULT_FILTERS.saleStatus
      this.appVisibility = DEFAULT_FILTERS.appVisibility
      this.includeSubPackages = DEFAULT_FILTERS.includeSubPackages

      this.handleClickSearch()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}

.wrapper {
  padding: ($space / 2) $space;
}

.filter-actions {
  padding-top: 12px;
}
</style>
